import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'app/data.service';
import { ConfirmationBoxComponent } from 'app/components/confirmation-box/confirmation-box.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-view-property-type',
  templateUrl: './view-property-type.component.html',
  styleUrls: ['./view-property-type.component.css']
})
export class ViewPropertyTypeComponent implements OnInit {
	propertyTypes:any[];
	propertyId:number;
	propertyIndex:number;

  constructor(private dataService : DataService, private dialog: MatDialog, private notification: MatSnackBar) { }

  propertyType: FormGroup = new FormGroup({
    type: new FormControl('', [Validators.required])
  })

  ngOnInit(): void {
  	this.dataService.getPropertyTypes()
  		.subscribe((data:any) => {
  			this.propertyTypes = data.propertyTypes;
  		})
  }

  formValue(type,index){
    this.propertyType.setValue({type: type.type})
  	this.propertyId = type.id;
  	this.propertyIndex = index;
  }

  delete(type, index){
	let dialogRef = this.dialog.open(ConfirmationBoxComponent, {
		width: '400px',
		data: {
			text: 'Are you sure you want to delete this item?'
		}
	})
	dialogRef.afterClosed().subscribe(result => {
		if(result){
			this.dataService.deletePropertyType(type.id)
				.subscribe(data => {
					if(data.status){
						this.propertyTypes.splice(index, 1)
						this.openNotification(data.message)
					}
				}, error => {
					if(error.error.message){
						this.openNotification(error.error.message)
					}
				})
		}
	})
  }

  editPropertyType(value){
  	if(this.propertyType.valid){
  		this.dataService.updatePropertyType(this.propertyId, value)
			.subscribe( (response:any) => {
				if(response.status){
					this.openNotification(response.message)
					this.propertyTypes.splice(this.propertyIndex, 1, response.propertyType);
				}
			}, error=> {
				if(error.error.message){
					this.openNotification(error.error.message)
				}
			});
  	}
  }

  openNotification(msg){
	this.notification.open(msg, 'Cancel', {
		duration: 2000,
		horizontalPosition: 'right'
	})
  }

  scroll(el:HTMLElement){
  	el.scrollIntoView();
  }
}

